import { SupportScreen } from '@/screens/support-screen/SupportScreen'

export default function () {
  return <SupportScreen />
}
